var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 23.9H12.2333C11.1833 23.9 10.3333 23.05 10.3333 22V12.9C10.3333 11.85 11.1833 11 12.2333 11H27.4333C28.4833 11 29.3333 11.85 29.3333 12.9V18",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5123 15.971C22.4393 16.898 22.4393 18.402 21.5123 19.33C20.5853 20.257 19.0813 20.257 18.1533 19.33C17.2263 18.403 17.2263 16.899 18.1533 15.971C19.0813 15.043 20.5853 15.043 21.5123 15.971",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 24.8V22C30.3333 21.226 28.7653 20.6 26.8333 20.6C24.9013 20.6 23.3343 21.227 23.3333 22V27.6C23.3343 28.373 24.9003 29 26.8333 29C28.7663 29 30.3323 28.373 30.3333 27.6V22",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3342 24.8C23.3342 25.573 24.9012 26.2 26.8342 26.2C28.7672 26.2 30.3342 25.573 30.3342 24.8",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 21H13.3333",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 14H25.3333",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.1342f70348c4809d012007cbbdb79574.svg";
export { ForwardRef as ReactComponent };